module.exports = __webpack_public_path__ + "static/media/promotions.4fc9788a.svg";